export const INPUT_SELECT = 'INPUT_SELECT';
export const INPUT_TEXT = 'INPUT_TEXT_CHANGE';
export const INPUT_TEXT_AREA = 'INPUT_TEXT_AREA_CHANGE';
export const INPUT_CHECKBOX = 'CHECKBOX_SELECTED';
export const INPUT_CHECKBOX_LIST = 'INPUT_CHECKBOX_LIST';
export const INPUT_DATE = 'DATE_SELECTED';
export const INPUT_RADIO = 'INPUT_RADIO_CHANGE';
export const INPUT_CAMERA = 'INPUT_CAMERA';
export const INPUT_SIGNATURE = 'INPUT_SIGNATURE';
